import Logo from '../assets/images/logo-white.png'
/**
 * HeaderLogo Component
 *
 * This component renders the company or application logo inside a styled header section.
 * The logo is wrapped within a flex container with padding for proper spacing.
 *
 * @component
 * @returns {JSX.Element} A header logo section.
 */
export default function HeaderLogo() {
    return (
        <>
            <div className='bg-dash'>
                <div className='flex p-12'>
                    <div>
                        <img className='w-3/4' src={Logo} alt='logo' />
                    </div>
                </div>
            </div>
        </>
    )
}
